import {RequestStatus, RequestStatusesEnum} from '@innowise-group/core';

export const getIconByRequestType = (type: RequestStatus): string => {
  switch (type) {
    case RequestStatusesEnum.Approved:
      return 'u_check-circle';
    case RequestStatusesEnum.InClarification:
    case RequestStatusesEnum.Conflict:
      return 'u_clock-seven';
    case RequestStatusesEnum.Rejected:
      return 'u_exclamation-triangle';
    case RequestStatusesEnum.Delayed:
      return 'u_multiply';
    case RequestStatusesEnum.Canceled:
      return 'u_multiply';
  }
};

export default getIconByRequestType;
